import React, {useRef} from "react";
import {Modal} from "components";
import {useDispatch, useSelector} from "react-redux";
import {getFanFactBySquadId} from "apps/DRAW_PREDICTOR/modules/selectors";
import {hideFanFact} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import {media} from "assets/css/media";
import {ReactComponent as FanFactLogo} from "apps/DRAW_PREDICTOR/assets/images/fanFactLogo.svg";
import closeIcon from "assets/images/icons/closeWhite.svg";
import {useClickAway} from "react-use";

const Inner = styled.div`
	background: #ffffff;
`;
const Header = styled.header`
	background: linear-gradient(227.93deg, #8a1538 0%, #8a1538 25%, #1c0111 100%);
	height: 200px;
	position: relative;
	&:after {
		content: "";
		position: absolute;
		bottom: 0;
		transform: translateY(50%);
		width: 100%;
		height: 60px;
		border-radius: 75%;
		background: #fff;
		@media (max-width: ${media.mobile}) {
			height: 30px;
		}
	}
`;
const Body = styled.div`
	padding: 30px;
	text-align: center;
	h2 {
		font-family: "Qatar2022";
		font-style: normal;
		font-weight: 700;
		font-size: 25px;
		line-height: 120%;
		color: #ae9142;
		margin-bottom: 20px;
	}
`;

const Fact = styled.p`
	font-family: "Graphik";
	font-weight: 400;
	font-size: 18px;
	line-height: 160%;
	margin-bottom: 40px;
	color: #03122b;
`;

const Sponsor = styled.p`
	color: #8f1838;
	font-weight: 600;
	font-size: 10px;
	text-transform: uppercase;
`;

export const FanFactModal: React.FC = () => {
	const fact = useSelector(getFanFactBySquadId);
	const dispatch = useDispatch();
	const {t} = useTranslation(LANGUAGE_PATH);
	const ref = useRef(null);
	useClickAway(ref, () => {
		closeModal();
	});

	const closeModal = () => {
		dispatch(hideFanFact());
	};
	if (!fact) {
		return null;
	}

	return (
		<Modal onClose={closeModal} closeIcon={closeIcon}>
			<Inner ref={ref}>
				<Header />
				<Body>
					<h2>{t("modal.fact.header")}</h2>
					<Fact>{fact}</Fact>
					<FanFactLogo />
					<Sponsor>{t("modal.fact.partner")}</Sponsor>
				</Body>
			</Inner>
		</Modal>
	);
};
